






















import { Component, Prop, Vue, Watch } from 'vue-property-decorator'

@Component
export default class BaseDropdown extends Vue {
    @Prop({ type: Boolean }) forceOpen!: boolean
    @Prop({ type: Boolean }) clickable!: boolean

    trigger = false
    forceClose = false

    $refs!: {
        dropdown: HTMLElement
    }

    @Watch('$route')
    onRouteChanged() {
        this.fastClose()
    }

    fastClose() {
        this.forceClose = true
        setTimeout(() => {
            this.forceClose = false
        }, 150)
    }

    on() {
        this.trigger = !this.trigger
    }

    close() {
        this.trigger = false
    }
}
